import { Frog, Koala, Parrot } from 'assets/images';

export * from './api';
export * from '../graphql/AtlassianAccountUserQuery';
export * from '../graphql/UnifiedAccountQuery';

export const BASE_PATH = '/profile';

export enum IMAGE_SIZE {
  SMALL = 128,
  MEDIUM = 256,
  LARGE = 512,
  XLARGE = 1024,
}

export enum DROPDOWN_ACTION_TEXT {
  CHANGE_PRIMARY = 'Change primary',
  MAKE_PRIMARY = 'Make primary',
  UNLINK_ACCOUNT = 'Unlink from primary',
}

export enum CERTIFICATE_NAME_ABBREVIATION {
  EXPERT_EMERITUS = 'ACP-EE',
}

export enum CERTIFICATE_STATUS {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export const PROFILE_AVATARS = [Frog, Parrot, Koala];

export const URL_REGEX = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/gim;

// export const CERTIFICATE_DEFAULT_URL =
//   'https://university.atlassian.com/student/activity/836769-get-certified';

// at time of update, CERTIFICATE_DEFAULT_URL not available. kept old location above as comment.
export const CERTIFICATE_DEFAULT_URL = '/learning/hub/certifications';

//LEARNING_BADGES_DEFAULT_URL page does not exist yet
export const LEARNING_BADGES_DEFAULT_URL = '/learning/catalog';

export const PEER_KUDOS_DEFAULT_URL =
  '/forums/Community-Kudos-Feedback/Welcome-to-the-Atlassian-Community-Kudos-program/ba-p/2148250';

export enum SCREEN_NAME {
  PROFILE = 'profileScreen',
  EDIT_PROFILE = 'editProfileScreen',
  CERTIFICATIONS = 'certificationsFullListScreen',
  GROUPS = 'groupsFullListScreen',
  BADGES = 'badgesFullListScreen',
}

export const STATSIG_STATE = {
  LOADING: 'loading',
  ERROR: 'error',
  INITIALIZED: 'initialized',
};

// default asset for Forums groups without set custom image - same url on every Forums env
export const DEFAULT_FORUMS_GROUP_IMG_URL =
  '/forums/s/html/@1A61952945A0A4487EA6608283EECA5F/assets/img/group-meeples.png';
